/**
 * The login cookies (the API token and the cached user), kept on the exact host
 * that set them.
 *
 * They used to be written with `domain` set to the parent domain, for example
 * `.bookfocal.com`. That made them readable by any script on any bookfocal.com
 * host, including pages that render photographers' own embeds and HTML
 * (site.bookfocal.com and the preview hosts). They are now host-only. A copy an
 * older build left on the parent domain is moved onto this host once, then
 * removed, so nobody is signed out by the change.
 */
export function createLoginCookies({ Cookies, parentDomain, secure }) {
  const options = secure ? { expires: 2, secure: true } : { expires: 2 }
  const hasParent = typeof parentDomain === 'string' && parentDomain.startsWith('.')

  const set = (name, value) => Cookies.set(name, value, options)

  const get = (name) => Cookies.get(name)

  const remove = (name) => {
    Cookies.remove(name)
    if (hasParent) Cookies.remove(name, { domain: parentDomain })
  }

  const migrate = (name) => {
    if (!hasParent) return
    const value = Cookies.get(name)
    if (value === undefined) return
    Cookies.remove(name, { domain: parentDomain })
    // If the browser also holds a host-only copy, that one wins and is kept.
    if (Cookies.get(name) === undefined) set(name, value)
  }

  return { set, get, remove, migrate }
}
